import { useSelector, shallowEqual } from 'react-redux';
import State, { OptimizelyDecisionsSlice } from 'types/State';

export interface OptimizelyDecisionsParams {
  testLeadCTA?: boolean;
}

export default function useOptimizelyDecisions(): OptimizelyDecisionsParams {
  const decisions = useSelector<State, OptimizelyDecisionsSlice>(
    (state) => state.optimizelyDecisions,
    shallowEqual
  );

  // camelcase decisions
  const testLeadCTA = decisions?.new_test_lead_cta || false;

  return {
    testLeadCTA,
  };
}
